import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tag', 'table', 'tags', 'tagTemplate', 'row'];

  cancel() {
    this.dispatch('cancel');
  }

  confirm() {
    this.dispatch('confirm');
  }

  sort({ params: { sortBy } }) {
    const sortTargets = this.rowTargets;
    let sortDirection;
    if (this.tableTarget.dataset.sortedBy === sortBy
      && this.tableTarget.dataset.sortDirection === 'asc') {
      sortDirection = 'desc';
    } else {
      sortDirection = 'asc';
    }

    sortTargets.sort((targetA, targetB) => {
      const weightA = targetA.dataset[sortBy] || '';
      const weightB = targetB.dataset[sortBy] || '';

      if (weightA === weightB) {
        return 0;
      } if (weightA > weightB) {
        return (sortDirection === 'asc' ? 1 : -1);
      }
      return (sortDirection === 'asc' ? -1 : 1);
    });

    this.tableTarget.inner_html = '';
    sortTargets.forEach((e) => { this.tableTarget.appendChild(e); });
    this.tableTarget.dataset.sortedBy = sortBy;
    this.tableTarget.dataset.sortDirection = sortDirection;
  }

  checkHandler(e) {
    const { name } = e.target.dataset;
    const { value } = e.target.dataset;

    if (e.target.checked) {
      this.createTag(name, value);
    } else {
      this.removeTag(value.toString());
    }
  }

  createTag(name, value) {
    if (this.tagTargets.find((tag) => tag.dataset.value === value)) {
      return;
    }

    const newTag = this.tagTemplateTarget.cloneNode(true);
    newTag.querySelector('.label').innerHTML = name;
    newTag.dataset.value = value;
    newTag.classList.remove('hidden');
    this.tagsTarget.appendChild(newTag);
  }

  removeTag(value) {
    this.tagTargets.forEach((target) => {
      if (target.dataset.value === value) {
        target.remove();
      }
    });
  }

  closeTagHandler(e) {
    const { element } = e.detail;
    this.rowTargets.forEach((target) => {
      if (target.dataset.value === element.dataset.value) {
        const input = target.querySelector('input');
        input.checked = false; // eslint-disable-line no-param-reassign
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    setTimeout(() => { element.remove(); }, 0);
  }
}
